import "./index.css"

// src/main.tsx
import React, { Suspense } from "react"
import ReactDOM from "react-dom/client"
import { RouterProvider } from "react-router"

// Import RouterProvider from react-router v7
import {
  QueryClient,
  QueryClientProvider,
} from "@tanstack/react-query"

// Import the pre-configured router
import { router } from "./router"

// Create a query client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 3,
      staleTime: 1000 * 60 * 5, // 5 minutes
    },
  },
})

// Loading fallback component
// eslint-disable-next-line react-refresh/only-export-components
function LoadingFallback() {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900" />
    </div>
  )
}

// App wrapper with Suspense for lazy-loaded routes
// eslint-disable-next-line react-refresh/only-export-components
function App() {
  return (
    <Suspense fallback={<LoadingFallback />}>
      <RouterProvider router={router} />
    </Suspense>
  )
}

// Ensure DOM is ready before rendering
const rootElement = document.getElementById("root")
if (!rootElement) {
  throw new Error("Failed to find root element")
}

// Create root and render
const root = ReactDOM.createRoot(rootElement)

// Render app with all providers
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
)